/*
Flanges

  --diameter <float::enum> | inches | ['6 1/16th', '6 5/16th']
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Flanges'
const id = 'eZeuY52Wd7cywhCXk8Ee'

export default {
  name,
  id,
  filters,
  headers,
  form
}
